function slider() {
  const sliders = document.querySelectorAll('.slider-video-wrapper-v2 .splide');
  
  sliders.forEach(slider => {
    let splideInstance;

    const wrapper = slider.closest('.slider-video-wrapper-v2');
    const mobileSpeed = parseInt(wrapper.dataset.mobileSpeed) || 1000;
    const desktopSpeed = parseInt(wrapper.dataset.desktopSpeed) || 1000;

    // Helpers for desktop-only video hover behavior
    // Consider both viewport width and actual hover capability to avoid triggering on touch devices
    const isDesktop = () => {
      const wide = window.innerWidth >= 1024;
      const canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      return wide && canHover;
    };

    function markBoxesWithVideo() {
      const boxes = slider.querySelectorAll('.box-video');
      boxes.forEach(box => {
        const hasNative = box.querySelector('.wp-block-video video');
        const hasEmbed = box.querySelector('.wp-block-embed iframe');
        if (hasNative || hasEmbed) {
          box.classList.add('has-video');
        } else {
          box.classList.remove('has-video');
        }
      });
    }

    function playNative(video) {
      if (!video) return;
      try {
        video.muted = true;
        const p = video.play();
        if (p && typeof p.catch === 'function') p.catch(() => {});
      } catch (e) {}
    }

    function pauseNative(video, reset = true) {
      if (!video) return;
      try {
        video.pause();
        if (reset) video.currentTime = 0;
      } catch (e) {}
    }

    function isYouTube(iframe) {
      const src = (iframe?.src || '').toLowerCase();
      return src.includes('youtube.com') || src.includes('youtu.be');
    }

    function isVimeo(iframe) {
      const src = (iframe?.src || '').toLowerCase();
      return src.includes('vimeo.com');
    }

    function ensureAutoplayPermission(iframe) {
      if (!iframe) return;
      const current = (iframe.getAttribute('allow') || '').toLowerCase();
      const required = ['autoplay', 'encrypted-media', 'picture-in-picture', 'fullscreen'];
      const merged = new Set(current.split(/\s*;\s*/).filter(Boolean));
      required.forEach(k => merged.add(k));
      iframe.setAttribute('allow', Array.from(merged).join('; '));
    }

    function setUrlParams(urlStr, params) {
      try {
        const url = new URL(urlStr, window.location.origin);
        Object.keys(params || {}).forEach(key => {
          const val = params[key];
          if (val === undefined || val === null) return;
          url.searchParams.set(key, String(val));
        });
        return url.toString();
      } catch (e) {
        return urlStr;
      }
    }

    function prepareIframe(iframe) {
      if (!iframe || iframe.dataset.embedPrepared) return;
      try {
        if (isYouTube(iframe)) {
          // Make sure YT player accepts JS API and does NOT auto-play by default
          const updatedSrc = setUrlParams(iframe.src || '', {
            enablejsapi: 1,
            playsinline: 1,
            rel: 0,
            autoplay: 0
          });
          if (updatedSrc && updatedSrc !== iframe.src) {
            iframe.src = updatedSrc;
          }
          ensureAutoplayPermission(iframe);
        } else if (isVimeo(iframe)) {
          const updatedSrc = setUrlParams(iframe.src || '', {
            autopause: 1,
            playsinline: 1,
            autoplay: 0
          });
          if (updatedSrc && updatedSrc !== iframe.src) {
            iframe.src = updatedSrc;
          }
          ensureAutoplayPermission(iframe);
        }
        iframe.dataset.embedPrepared = '1';
      } catch (e) {}
    }

    function prepareEmbeds() {
      const iframes = slider.querySelectorAll('.wp-block-embed iframe');
      iframes.forEach(prepareIframe);
    }

    function playEmbed(iframe) {
      if (!iframe) return;
      try {
        // Ensure attributes/params in case this is the first interaction
        prepareIframe(iframe);
        if (isYouTube(iframe)) {
          // Mute first to comply with autoplay policies, then play
          iframe.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'mute', args: [] }), '*');
          iframe.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'playVideo', args: [] }), '*');
        } else if (isVimeo(iframe)) {
          iframe.contentWindow?.postMessage({ method: 'setVolume', value: 0 }, '*');
          iframe.contentWindow?.postMessage({ method: 'play' }, '*');
        }
      } catch (e) {}
    }

    function pauseEmbed(iframe, reset = true) {
      if (!iframe) return;
      try {
        if (isYouTube(iframe)) {
          // Pause first
          iframe.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), '*');
          // Then reset to 0 if requested
          if (reset) {
            iframe.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'seekTo', args: [0, true] }), '*');
          }
        } else if (isVimeo(iframe)) {
          // Pause first
          iframe.contentWindow?.postMessage({ method: 'pause' }, '*');
          // Then reset to 0 if requested
          if (reset) {
            iframe.contentWindow?.postMessage({ method: 'setCurrentTime', value: 0 }, '*');
          }
        }
      } catch (e) {}
    }

    function stopOtherVideos(exceptBox) {
      // Only act on boxes that are actually marked as playing to avoid
      // triggering spinners on idle embeds.
      const playingBoxes = slider.querySelectorAll('.box-video.has-video.is-playing');
      playingBoxes.forEach(box => {
        if (!box || box === exceptBox) return;
        box.classList.remove('is-playing');
        const vid = box.querySelector('.wp-block-video video');
        const iframe = box.querySelector('.wp-block-embed iframe');
        pauseNative(vid);
        pauseEmbed(iframe);
      });
    }

    let hoverBound = false;
    function bindDesktopHoverHandlers() {
      // Ensure embeds are ready (params and allow attributes)
      // Note: we prepare embeds on mount; no need to re-prepare on hover to avoid any chance of mass autoplay
      markBoxesWithVideo();

      // Delegated hover handlers to support dynamically added/updated boxes
      // Use mouseover/mouseout because mouseenter/mouseleave do not bubble
      const onOver = (e) => {
        if (!isDesktop()) return;
        const box = e.target.closest('.box-video.has-video');
        if (!box || !slider.contains(box)) return;
        // Ensure we're actually entering the box from outside it
        const related = e.relatedTarget;
        if (related && box.contains(related)) return;
        const nativeVideo = box.querySelector('.wp-block-video video');
        const iframe = box.querySelector('.wp-block-embed iframe');
        box.classList.add('is-playing');
        stopOtherVideos(box);
        if (nativeVideo) playNative(nativeVideo);
        if (iframe) playEmbed(iframe);
      };

      const onOut = (e) => {
        if (!isDesktop()) return;
        const box = e.target.closest('.box-video.has-video');
        if (!box || !slider.contains(box)) return;
        // Ensure we're actually leaving the box to outside it
        const related = e.relatedTarget;
        if (related && box.contains(related)) return;
        const nativeVideo = box.querySelector('.wp-block-video video');
        const iframe = box.querySelector('.wp-block-embed iframe');
        box.classList.remove('is-playing');
        if (nativeVideo) pauseNative(nativeVideo);
        if (iframe) pauseEmbed(iframe);
      };

      // Store references for unbinding later
      slider._onBoxOver = onOver;
      slider._onBoxOut = onOut;
      slider.addEventListener('mouseover', onOver);
      slider.addEventListener('mouseout', onOut);

      hoverBound = true;
    }

    function unbindHoverHandlers() {
      if (slider._onBoxOver) slider.removeEventListener('mouseover', slider._onBoxOver);
      if (slider._onBoxOut) slider.removeEventListener('mouseout', slider._onBoxOut);
      delete slider._onBoxOver;
      delete slider._onBoxOut;
      hoverBound = false;
    }

    function initSlider() {
      if (splideInstance) splideInstance.destroy();

      splideInstance = new Splide(slider, {
        type: 'slide',
        speed: window.innerWidth < 1024 ? mobileSpeed : desktopSpeed,
        perPage: 1,
        perMove: 1,
        gap: '0',
        autoHeight: true,
        lazyload: 'sequential',
        rewind: true,
        mediaQuery: 'min',
        pagination: true,
        arrows: false,
        autoplay: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        interval: 7000,
        focusableNodes: true,
        fixedWidth: '16.75rem',
        breakpoints: {
          1024: {
            perPage: 1,
            perMove: 1,
            gap: '1.5rem',
            pagination: false,
            arrows: true,
            fixedWidth: '21.25rem',
            autoplay: false,
            rewind: false,
          }
        },
      });

      splideInstance.on('mounted', handleMounted);
      splideInstance.on('move', handleMove);
      splideInstance.mount();

      // Prepare iframes now that slides are in the DOM
      prepareEmbeds();

      // Bind hover behavior after mount (slides are in DOM)
      if (isDesktop()) {
        bindDesktopHoverHandlers();
      } else {
        unbindHoverHandlers();
      }
    }

    function handleMounted() {
      const slides = slider.querySelectorAll('.splide__slide');
      slides[0]?.classList.add('scale-in');
    }

    function handleMove(newIndex, prevIndex, destIndex) {
      const slides = slider.querySelectorAll('.splide__slide');
      slides.forEach((slide, index) => {
        slide.classList.toggle('scale-in', index === destIndex);
        slide.classList.toggle('fade-out', index < destIndex);
      });
      // Pause any playing videos when slide changes
      stopOtherVideos();
    }

    function sliderNavPosition() {
      const sliderTextHeight = document.querySelectorAll('.slider-video .slider-video__text');
      sliderTextHeight.forEach(textHeight => {
        const sliderNav = slider.querySelector('.splide__nav-wrapper');
        if (sliderNav) {
          sliderNav.style.top = `${textHeight.offsetHeight / 16}rem`;
        }
      });
    }

    function updateTextHeightVariable() {
      // Find the nearest .slider-video-v2 section and its text block
      const section = slider.closest('.slider-video-v2');
      if (!section) return;
      const text = section.querySelector('.slider-video__text');
      if (!text) return;
      const h = text.offsetHeight || 0;
      section.style.setProperty('--slider-text-height', `${h}px`);
    }

    initSlider();
    sliderNavPosition();
    updateTextHeightVariable();

    function handleResize() {
      // Re-init slider for speed and arrows changes
      initSlider();
      // Bind/unbind hover handlers based on breakpoint
      if (isDesktop()) {
        bindDesktopHoverHandlers();
      } else {
        unbindHoverHandlers();
        // Also ensure all videos are paused when switching to mobile
        stopOtherVideos();
      }
      sliderNavPosition();
      updateTextHeightVariable();
    }

    // Optional: observe changes in the text block to keep variable updated
    const sectionForRO = slider.closest('.slider-video-v2');
    const textForRO = sectionForRO ? sectionForRO.querySelector('.slider-video__text') : null;
    if (window.ResizeObserver && textForRO) {
      const ro = new ResizeObserver(() => updateTextHeightVariable());
      ro.observe(textForRO);
    }

    window.addEventListener('resize', handleResize);
  });
}

document.addEventListener('DOMContentLoaded', slider);

// Hover guard moved from dist/js/blocks/slider-video-hover-guard-v2.js to assets to ensure Webpack builds it
(function(){
  function isRealDesktop(){
    var wide = window.innerWidth >= 1024;
    var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    return wide && canHover;
  }

  function stopper(e){
    // If not real desktop, stop hover events from reaching slider handlers
    if (isRealDesktop()) return;
    var target = e.target && e.target.closest ? e.target.closest('.slider-video-wrapper-v2 .splide .box-video') : null;
    if (target) {
      e.stopImmediatePropagation();
    }
  }

  function update(){
    if (!isRealDesktop()) {
      if (!document._svw2StopperActive) {
        document.addEventListener('mouseover', stopper, true);
        document.addEventListener('mouseout', stopper, true);
        document._svw2StopperActive = true;
      }
    } else {
      if (document._svw2StopperActive) {
        document.removeEventListener('mouseover', stopper, true);
        document.removeEventListener('mouseout', stopper, true);
        document._svw2StopperActive = false;
      }
    }
  }

  document.addEventListener('DOMContentLoaded', update);
  window.addEventListener('resize', update);
})();
